import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { BackgroundJobStatus } from '../models/background-job-status.model';

@Injectable({
  providedIn: 'root'
})
export class BackgroundJobService {

    constructor(private apiService: ApiService) {}
  
    public getBackgroundJob(jobId: string): Observable<BackgroundJobStatus> {
      return this.apiService.get(`/api/BackgroundJob/status/${jobId}`);
    }
}
